module.exports = __webpack_public_path__ + "static/media/fusion4quality.7c64a45b.png";